import { Attributes, Misc, NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class SecurityHoldingSearchCriteria extends ValueObject {

    @Rules.Required()
    public staticServiceProviderFileGroupingID: number = 0;

    public serviceProviderGroupingName: string | null = null;

    public rawAccountNumber: string = "";

    public clientAccountNumber: string = "";

    public instrument: string = "";

    public instrumentID: number | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public date: Date | null = null;
}